// İSG uzmanı portalı — Eğitim & Test (Training) TanStack Query anahtarları (api-contract
// §16, tenant-scoped authoring). Liste anahtarı parametreleri içerir (filtre/sayfa değişince
// yeniden çeker); invalidasyon önek (prefix) ile yapılır: `['trainings','list']` tüm liste
// sorgularını, `['trainings','detail',uuid]` bir eğitimin detayını (video + soru seti/cevap
// anahtarı dahil, hepsi tek `GET /trainings/{uuid}` içinde) kapsar.
//
// Taşeron (§13) / İş İzni (§14) anahtarlarından AYRIDIR — Eğitim tek firmaya kapsanmış tenant
// authoring modülüdür (modül Value = `training`).

import type { TrainingListParams } from '@isgportal/shared';

export const trainingKeys = {
  /** Tüm eğitim sorgularının kök öneki — invalidasyon için. */
  all: () => ['trainings'] as const,
  /** Tüm liste sorgularının öneki (arama/durum/sayfa varyantlarını kapsar). */
  list: () => ['trainings', 'list'] as const,
  /** Sayfalı + filtreli liste — parametreli. */
  listParams: (params: TrainingListParams) => ['trainings', 'list', params] as const,
  /** Erişim sondası (gate) — hafif liste probu (page=1, pageSize=1). */
  access: () => ['trainings', 'access'] as const,
  /** Tek eğitim detayı (video + soru seti/cevap anahtarı dahil). */
  detail: (uuid: string) => ['trainings', 'detail', uuid] as const,
} as const;
